import apiClient from './api.js';

// Cache for affiliate link requests
const affiliateCache = new Map();
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export const generateReferralLink = async (userId) => {
  try {
    if (!userId) {
      console.warn('generateReferralLink: No userId provided');
      return { success: false, message: 'User ID is required' };
    }

    // Check cache first
    const cacheKey = `referral_${userId}`;
    const cached = affiliateCache.get(cacheKey);
    if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
      console.log('generateReferralLink: Returning cached response');
      return cached.data;
    }

    console.log('generateReferralLink: Making API call for user:', userId);

    // Make the API call
    const response = await apiClient.post('/api/referral/generate', { userId });

    console.log('generateReferralLink: API response:', response.data);

    // Cache successful responses
    if (response.data && response.data.success !== false) {
      affiliateCache.set(cacheKey, {
        data: response.data,
        timestamp: Date.now()
      });
    }

    return response.data;
  } catch (error) {
    console.warn('generateReferralLink: API call failed:', error.message);

    // Return a structured error response instead of throwing
    return {
      success: false,
      message: 'Failed to generate referral link',
      error: error.message,
      details: error.response?.data || null
    };
  }
};

export const generateAffiliateLink = async (userId) => {
  try {
    if (!userId) {
      console.warn('generateAffiliateLink: No userId provided');
      return { success: false, message: 'User ID is required' };
    }

    // Check cache first
    const cacheKey = `affiliate_${userId}`;
    const cached = affiliateCache.get(cacheKey);
    if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
      console.log('generateAffiliateLink: Returning cached response');
      return cached.data;
    }

    console.log('generateAffiliateLink: Making API call for user:', userId);

    // Make the API call
    const response = await apiClient.post('/api/referral/affiliate/generate', { userId });

    console.log('generateAffiliateLink: API response:', response.data);

    // Cache successful responses
    if (response.data && response.data.success !== false) {
      affiliateCache.set(cacheKey, {
        data: response.data,
        timestamp: Date.now()
      });
    }

    return response.data;
  } catch (error) {
    console.warn('generateAffiliateLink: API call failed:', error.message);

    // Return a structured error response instead of throwing
    return {
      success: false,
      message: 'Failed to generate affiliate link',
      error: error.message,
      details: error.response?.data || null
    };
  }
};

export const getReferralStats = async (userId) => {
  try {
    const response = await apiClient.get(`/api/monetization/stats/${userId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching referral stats:', error);
    throw error;
  }
};

export const getReferralEarnings = async (userId) => {
  try {
    const response = await apiClient.get(`/api/referral/earnings/${userId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching referral earnings:', error);
    throw error;
  }
};
